import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import type { State } from '@jira/issue__redux-state-types/src/ReduxState.types.tsx';
import type { Field } from '@atlassian/jira-issue-shared-types/src/common/types/field-type.tsx';
import { CHILDREN_ISSUES } from '@atlassian/jira-platform-field-config/src/index.tsx';
import {
	fieldSelector,
	childIssuesLimitUrlSelector,
} from '../../../common/state/selectors/field-selector.tsx';

const childrenIssueSelector: (arg1: State) => Field | undefined = fieldSelector(CHILDREN_ISSUES);

export const hasChildrenIssuesSelector = createSelector(
	childrenIssueSelector,
	childIssuesLimitUrlSelector,
	(childrenIssues, getChildIssuesLimitUrl) =>
		childrenIssues
			? !isEmpty(childrenIssues.value) || Boolean(getChildIssuesLimitUrl(CHILDREN_ISSUES))
			: false,
);
